/**
 * « Paramètres des spectateurs » (`spectators`): the ticket shop settings. The head and its link, then
 * every section top to bottom (dates, access, fees, tickets, products, promo codes), then Save. Each
 * section step opens its card (`section`); the anchors come from `tourKey={section}` on
 * OrganizerSection (SpectatorSettingsPage).
 */
export const SPECTATOR_SETTINGS_TOUR = {
    id: 'spectator-settings',
    version: 1,
    paths: ['spectators'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Your ticket shop',
            description:
                'Set up here the tickets you sell to the public: dates, prices, stock. « Preview » opens the shop as spectators will see it.',
        },
        {
            key: 'link',
            target: '[data-tour="page-copy-link"]',
            placement: 'bottom',
            title: 'The ticket shop link',
            description: 'Copies the address of your ticket shop, to share it with the public.',
        },
        {
            key: 'dates',
            target: '[data-tour="sec-spub"]',
            section: 'spub',
            placement: 'bottom',
            title: 'Sales dates',
            description:
                'Ticket sales open and close on these dates by themselves. Without an opening date, the shop stays closed.',
        },
        {
            key: 'access',
            target: '[data-tour="sec-saccess"]',
            section: 'saccess',
            placement: 'bottom',
            title: 'Protect the shop',
            description:
                'Lock the ticket shop behind a password for a while, for a pre-sale or a private audience. Leave it off to sell to everyone.',
        },
        {
            key: 'fees',
            target: '[data-tour="sec-spay"]',
            section: 'spay',
            placement: 'bottom',
            title: 'Who pays the fees',
            description: 'Choose whether the platform fees are added to the spectator’s price or taken from yours.',
        },
        {
            key: 'tickets',
            target: '[data-tour="sec-stickets"]',
            section: 'stickets',
            placement: 'bottom',
            title: 'Your tickets',
            description:
                'Create each ticket type with its price and stock, and set the total number of places if you wish. At least one ticket is needed to sell.',
        },
        {
            key: 'products',
            target: '[data-tour="sec-sprods"]',
            section: 'sprods',
            placement: 'bottom',
            title: 'Extra products',
            description: 'T-shirts, drinks, goodies: items spectators can add to their order.',
        },
        {
            key: 'promos',
            target: '[data-tour="sec-spromos"]',
            section: 'spromos',
            placement: 'bottom',
            title: 'Promo codes',
            description:
                'A code gives a discount on one ticket or one product. A code cannot be changed once created: delete it and create a new one.',
        },
        {
            key: 'save',
            target: '[data-tour="page-save"]',
            placement: 'bottom',
            placementNarrow: 'top',
            title: 'Save your changes',
            description:
                'Tickets, products and codes are saved as soon as you create them; the rest applies when you save. A missing essential keeps the shop closed.',
        },
    ],
}

export default SPECTATOR_SETTINGS_TOUR
